<template>
  <div id="product-detail-bottom-container">
    <v-layout>
      <v-flex xs6 class="pa-1">
        <v-btn block outline color="primary" v-on:click="clickClose()" class="pa-0 ma-0">{{ $t('Cancel') }}</v-btn>
      </v-flex>
      <v-flex xs6 class="pa-1" v-if="status === 'show'">
        <v-btn depressed v-if="parseInt(getProductDetail.product_variant.product_variant.stock) - quantity < 0 && parseInt(getProductDetail.product_variant.use_stock) === 1" class="disabled-button ma-0">{{ $t('Buy_now') }}</v-btn>
        <add-to-cart
            class="product-detail-buy-now-component"
            v-on:click="clickClose()"
            v-else-if="typeof getProductDetail.product_variant.product_variant !== 'undefined'"
            v-bind:product-sku="getProductDetail.product_variant.product_variant.sku"
            v-bind:product-quantity="quantity"
            open-cart="true"
            v-bind:rp-label="$t('Buy_now')"
            mode="custom">
        </add-to-cart>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonVariantBottom',
  props: {
    quantity: {
      default: 1,
      type: Number
    },
    status: {
      default: '',
      type: String
    }
  },
  data: () => {
    return {
      data: ''
    }
  },
  computed: {
    ...mapGetters([
      'getProductDetail'
    ])
  },
  methods: {
    clickClose () {
      if (this.page === 'detail') {
        this.$router.push({name: 'ProductList'})
      } else {
        this.$parent.$emit('modalActive', false)
      }
    }
  }
}
</script>

<style type='text/css' lang='scss' scoped>
#product-detail-bottom-container {
  bottom: 0px;
  width: 100%;

  .disabled-button {
    background-color: #dddddd;
    color: #bdbdbe;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productVariants/bottom/index.vue